var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-easy-lightbox',{ref:"lightbox",attrs:{"visible":_vm.visible,"imgs":_vm.source,"index":_vm.index},on:{"hide":_vm.handleHide}}),_vm._t("default",null,{"show":function (src) { return _vm.showImg(src); }})],2)}
var staticRenderFns = []

export { render, staticRenderFns }